<aionz-header-bottom-sheet
  aionz-dialog-title
  (onClose)="close()">
  Unificar solicitações
</aionz-header-bottom-sheet>

<aionz-dialog-content class="merge-content">
  <div class="merge-meta">
    <div class="merge-meta-title">
      <mat-basic-chip class="merge-id-chip">#{{ data.id }}</mat-basic-chip>
      <span class="merge-title">{{ data.title }}</span>
      <span class="merge-this">esta solicitação</span>
    </div>
    <div class="merge-meta-info">
      <aionz-purchase-request-status [status]="data.status" />
      <span class="merge-requested-at">
        <mat-icon aria-hidden="true">calendar_month</mat-icon>
        Solicitado em {{ data.requestedAt | date: 'dd/MM/yy' }}
      </span>
    </div>
    @if (data.description && data.description !== data.title) {
      <p class="merge-description">{{ data.description }}</p>
    }
  </div>

  <p
    class="merge-context"
    role="note">
    <mat-icon
      class="cotai-gradient-text"
      aria-hidden="true"
      >auto_awesome</mat-icon
    >
    <span>
      O Cotai encontrou
      <strong
        >{{ commonProductsCount }}
        {{ commonProductsCount === 1 ? 'produto em comum' : 'produtos em comum' }}</strong
      >
      {{ contextWhere() }}. Compare abaixo como cada um está em cada solicitação; o ponto
      <span
        class="legend-dot"
        aria-hidden="true"></span>
      marca o que é diferente. Ao unificar, as
      solicitações selecionadas viram uma só e as originais são excluídas.
    </span>
  </p>

  <seed-card-table
    tableContent
    [scrollOnOverflow]="true">
    <seed-card-table-body>
      <table
        mat-table
        [dataSource]="dataSource()"
        matSort>
        <ng-container matColumnDef="select">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="checkbox-column">
            <mat-checkbox
              (change)="$event ? toggleAllRows() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"
              [aria-label]="checkboxLabel()">
            </mat-checkbox>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="checkbox-column">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)"
              [aria-label]="checkboxLabel(row)">
            </mat-checkbox>
          </td>
        </ng-container>

        @if (showPurchaseColumn) {
          <ng-container matColumnDef="purchase">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header="purchaseId">
              Solicitação
            </th>
            <td
              mat-cell
              *matCellDef="let row">
              <mat-basic-chip class="purchase-chip">#{{ row.purchaseId }}</mat-basic-chip>
            </td>
          </ng-container>
        }

        <ng-container matColumnDef="id">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            Código
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            {{ row.productId }}
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            Nome do Produto
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            <div class="product-name-cell">
              <span
                class="product-name"
                [aionzTooltip]="row.name"
                mode="message"
                >{{ row.name }}</span
              >
              @if (row.specification && row.specification !== '-') {
                <button
                  type="button"
                  class="product-tag-button"
                  [aionzTooltip]="row.specification"
                  mode="message"
                  aria-label="Informações adicionais do produto">
                  <mat-icon aria-hidden="true">info</mat-icon>
                </button>
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="current">
          <th
            mat-header-cell
            *matHeaderCellDef>
            Nesta solicitação (#{{ data.id }})
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            @let cmp = comparisonOf(row);
            @if (cmp.current; as current) {
              <div
                class="compare-cell">
                <span
                  class="compare-qty"
                  [class.compare-diff]="cmp.diff.quantity"
                  >{{ current.quantity | number }} {{ current.unit }}</span
                >
                <span
                  class="compare-line"
                  [class.compare-diff]="cmp.diff.costCenter"
                  >CC {{ costCenterLabel(current) || '—' }}</span
                >
                <span
                  class="compare-line compare-branch"
                  [class.compare-diff]="cmp.diff.branch">
                  <mat-icon aria-hidden="true">location_on</mat-icon>
                  {{ branchLabel(current) || 'Local de entrega não informado' }}
                </span>
                <span
                  class="compare-line compare-suppliers"
                  [class.compare-suppliers--empty]="!current.suppliers.length"
                  tabindex="0"
                  [aionzTooltipComponent]="current.suppliers.length ? itemSuppliersTooltipComponent : null"
                  [aionzTooltipData]="current.suppliers.length ? suppliersTooltip(row, current.suppliers) : null"
                  aionzTooltipPosition="below"
                  aionzTooltipClass="item-suppliers-tooltip"
                  mode="message">
                  <mat-icon aria-hidden="true">{{ current.suppliers.length ? 'storefront' : 'warning_amber' }}</mat-icon>
                  {{ suppliersLabel(current.suppliers) }}
                </span>
                <span
                  class="compare-line compare-requester"
                  [class.compare-diff]="cmp.diff.requester">
                  <mat-icon aria-hidden="true">person</mat-icon>
                  <span
                    class="requester-name"
                    [aionzTooltip]="current.requester.name"
                    mode="message"
                    >{{ current.requester.name }}</span
                  >
                </span>
              </div>
            } @else {
              <span class="compare-missing">Não está nesta solicitação</span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="other">
          <th
            mat-header-cell
            *matHeaderCellDef>
            {{ otherColumnLabel }}
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            @let cmp = comparisonOf(row);
            <div
                class="compare-cell">
                <span
                  class="compare-qty"
                  [class.compare-diff]="cmp.diff.quantity"
                  >{{ row.quantity | number }} {{ row.unit }}</span
                >
                <span
                  class="compare-line"
                  [class.compare-diff]="cmp.diff.costCenter"
                  >CC {{ costCenterLabel(row) || '—' }}</span
                >
                <span
                  class="compare-line compare-branch"
                  [class.compare-diff]="cmp.diff.branch">
                  <mat-icon aria-hidden="true">location_on</mat-icon>
                  @if (cmp.otherBranch === undefined) {
                    Carregando filial…
                  } @else {
                    {{ cmp.otherBranch || 'Local de entrega não informado' }}
                  }
                </span>
                <span
                  class="compare-line compare-suppliers"
                  [class.compare-suppliers--empty]="!row.suppliers.length"
                  tabindex="0"
                  [aionzTooltipComponent]="row.suppliers.length ? itemSuppliersTooltipComponent : null"
                  [aionzTooltipData]="row.suppliers.length ? suppliersTooltip(row, row.suppliers) : null"
                  aionzTooltipPosition="below"
                  aionzTooltipClass="item-suppliers-tooltip"
                  mode="message">
                  <mat-icon aria-hidden="true">{{ row.suppliers.length ? 'storefront' : 'warning_amber' }}</mat-icon>
                  {{ suppliersLabel(row.suppliers) }}
                  @if (newSuppliersCount(row, cmp.current); as novos) {
                    <span class="compare-new">+{{ novos }} ao unificar</span>
                  }
                </span>
                <span
                  class="compare-line compare-requester"
                  [class.compare-diff]="cmp.diff.requester">
                  <mat-icon aria-hidden="true">person</mat-icon>
                  <span
                    class="requester-name"
                    [aionzTooltip]="row.requester.name"
                    mode="message"
                    >{{ row.requester.name }}</span
                  >
                </span>
              </div>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"></tr>

        <tr
          class="mat-row"
          *matNoDataRow>
          <td
            class="mat-cell text-center py-3"
            [attr.colspan]="displayedColumns.length">
            Nenhum dado encontrado!
          </td>
        </tr>
      </table>
    </seed-card-table-body>
  </seed-card-table>
</aionz-dialog-content>

<aionz-dialog-actions
  align="end"
  class="merge-actions">
  <!-- Sem itens marcados o botão fica desabilitado: antes, unificar sem marcar puxava todos. -->
  <span
    class="merge-hint"
    aria-live="polite">
    @if (selection.hasValue()) {
      {{ selection.selected.length }} {{ selection.selected.length === 1 ? 'item marcado' : 'itens marcados' }}
    } @else {
      Marque os itens que deseja unificar.
    }
  </span>
  <button
    mat-stroked-button
    type="button"
    (click)="close()">
    Fechar
  </button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    [disabled]="!selection.hasValue()"
    (click)="unifyRequests()">
    Unificar solicitações
  </button>
</aionz-dialog-actions>
